export default "__VITE_ASSET__CynxNYe3__"